const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.170.2.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'sense-demo.qlik.com',
  appId: 'bf4a5d3c-b85e-447e-8d93-e63723bd0ca8',
};
const url = SenseUtilities.buildUrl(config);
const session = enigma.create({ schema, url });

export default session.open().then((global) => global.openDoc(config.appId));
